import React from 'react'
import classnames from 'classnames'
import { IProductImage } from '../../types/product'
import style from './index.module.scss'
import {
  CloudinaryImage,
  Sizes,
} from '@scentregroup/shared/hub-components/cloudinary-image'
import { SGPageTemplateImage } from '../../../../../../src/types/page-templates'

interface IProductImageProps {
  image?: IProductImage
  selected?: boolean
  sizes: Sizes
}

const ProductImage: React.FunctionComponent<
  React.PropsWithChildren<IProductImageProps>
> = ({ image, selected, sizes }) => {
  const templateImage: SGPageTemplateImage = {
    url: image?.url || '',
    alt: image?.description || image?.alt,
    type: 'SQUARE',
  }
  return (
    <div>
      {image?.url ? (
        <div className={style.imageWrapper}>
          <CloudinaryImage
            ratio="2/3"
            imageSetOrImage={templateImage}
            resizeMode="pad"
            sizes={sizes}
            className={classnames(style.image, style.border, {
              [style.selected]: selected,
            })}
          />
        </div>
      ) : (
        <div aria-hidden="true" className={style.noImageWrapper}>
          <div className={style.noImageLabel}>No image available</div>
        </div>
      )}
    </div>
  )
}

export default ProductImage
